<section class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">Conseils</h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    @if (conseils$ | async; as conseils) {
      @if (conseils.length > 0) {
        <div class="row">
          @for (conseil of conseils; track conseil) {
            <div class="col-sm-6 col-lg-4 col-xl-3 mb-4">
              <app-card [link]="conseil.id.toString()" [title]="conseil.date | date:'dd/MM/y'" [text]="conseil.titre"
                [image]="conseil.image ? (conseil.image.url | backResource) : ''">
              </app-card>
            </div>
          }
        </div>
      } @else {
        <div class="alert alert-info">Il n'y a aucun conseil à afficher</div>
      }
    }
  </div>
</section>
